<template>
    <div>
        <div class="flex items-start">
            <label v-if="label" class="label" :class="{ 'h-16': labelDefaultSpace }">
                {{ label }}
                <BaseRequiredStar v-if="$attrs.required" />
            </label>
            <div class="pt-2">
                <slot name="help"></slot>
            </div>
        </div>
        <div class="flex">
            <input
                type="text"
                :inputmode="inputMode"
                :class="{ 'input-error': isInvalid }"
                v-bind="$attrs"
                :maxlength="$attrs.maxlength || defaultMaxLength"
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                @keyup.enter="$emit('enter:pressed')"
            >
            <div class="min-w-20 w-20 bg-cyan-100 flex justify-center items-center -ml-1 rounded-r-md border border-gray-200" v-if="unit">
                <span class="text-gray-400 font-bold text-sm">{{ unit }}</span>
            </div>
        </div>
        <slot name="tip"></slot>
        <RecordTestVideo
            v-if="shouldShowRecordVideo"
            :record-uuid="recordVideoContext.record.value.uuid"
            :patient-uuid="recordVideoContext.patient.value.uuid"
            :test-key="videoKey"
            side="both"
            :label="videoTitle"
            @ensure-record="recordVideoContext.ensureRecordForVideo"
        />
    </div>
</template>

<script>

import { computed, inject, ref, useAttrs } from 'vue';
import RecordTestVideo from '../RecordTestVideo.vue';

export default {
    components: { RecordTestVideo },
    props: {
        label: {
            type: String,
            default: ''
        },
        labelDefaultSpace: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: [String, Number],
            default: ''
        },
        isInvalid: {
            type: Boolean,
            default: false
        },
        unit: {
            type: String
        },
        videoKey: {
            type: String,
            default: ''
        },
        // Usado quando o vídeo pertence a um grupo de campos (ex.: perna direita +
        // perna esquerda): o video-key vai no último campo, que não tem label própria.
        videoLabel: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const defaultMaxLength = ref(100);
        const attrs = useAttrs();
        const recordVideoContext = inject('recordVideoContext', null);
        const physicalSections = new Set(['lower', 'trunk', 'upper', 'clinical', 'rtp']);

        const inputMode = computed(() => {
            if (attrs.inputmode) return attrs.inputmode;
            return props.unit || attrs.maxlength ? 'decimal' : undefined;
        });

        const videoTitle = computed(() => props.videoLabel || props.label);

        const shouldShowRecordVideo = computed(() => {
            return Boolean(
                recordVideoContext &&
                props.videoKey &&
                videoTitle.value &&
                physicalSections.has(recordVideoContext.activeSection.value)
            );
        });

        return { defaultMaxLength, inputMode, recordVideoContext, shouldShowRecordVideo, videoTitle };
    }
}
</script>
